import { render, staticRenderFns } from "./SidebarTabs.vue?vue&type=template&id=ff3088b2&"
import script from "./SidebarTabs.vue?vue&type=script&lang=js&"
export * from "./SidebarTabs.vue?vue&type=script&lang=js&"
import style0 from "./SidebarTabs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports